<template>
  <div class="speech-bubble">
    <p v-if="title" class="speech-bubble__title">{{ title }}</p>
    <p class="speech-bubble__text">
      <template v-for="(part, index) in greetingParts">
        <strong v-if="part.bold" :key="`b-${index}`">{{ part.text }}</strong>
        <span v-else :key="`t-${index}`">{{ part.text }}</span>
      </template>
    </p>
  </div>
</template>

<script lang="ts">
import Vue from "vue";

export default Vue.extend({
  name: "AssistantCatHomeSpeechBubble",
  props: {
    title: {
      type: String,
      default: "",
    },
    greeting: {
      type: String,
      required: true,
    },
    username: {
      type: String,
      default: "",
    },
  },
  computed: {
    greetingParts(): Array<{ text: string; bold: boolean }> {
      const { greeting: text, username } = this;
      if (!username) {
        return [{ text, bold: false }];
      }
      const index = text.indexOf(username);
      if (index < 0) {
        return [{ text, bold: false }];
      }
      const parts: Array<{ text: string; bold: boolean }> = [];
      if (index > 0) {
        parts.push({ text: text.substring(0, index), bold: false });
      }
      parts.push({ text: username, bold: true });
      if (index + username.length < text.length) {
        parts.push({ text: text.substring(index + username.length), bold: false });
      }
      return parts;
    },
  },
});
</script>

<style lang="scss" scoped>
@import "@/style-common.scss";

.speech-bubble {
  box-sizing: border-box;
  width: 100%;
  padding: 16px;
  background: var(--color-background-normal);
  border-radius: var(--radius-md);
  box-shadow: var(--shadow-md);
  color: var(--color-text-normal);
}

.speech-bubble__title {
  margin: 0 0 4px;
  font-size: var(--font-size-md);
  font-weight: var(--font-weight-bold);
  line-height: var(--line-height-default);
}

.speech-bubble__text {
  margin: 0;
  font-size: var(--font-size-md);
  font-weight: var(--font-weight-regular);
  line-height: var(--line-height-default);
  display: -webkit-box;
  overflow: hidden;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 4;
  white-space: pre-line;

  strong {
    font-weight: var(--font-weight-bold);
  }
}
</style>
